var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg404 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 484,
    viewBox: "0 0 532 484",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "28.292%",
    x2: "73.776%",
    y1: "33.446%",
    y2: "81.373%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E1E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#E8E8EF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31%",
    stopColor: "#EFEFF4",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47%",
    stopColor: "#F5F5F8",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#F9F9FB",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#FCFCFD",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "89%",
    stopColor: "#FEFEFF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A5F6E1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.593%",
    stopColor: "#6CEAC0",
    stopOpacity: 0.413
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F4F4F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6FFFCC",
    stopOpacity: 0.709
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__e",
    x1: "50%",
    x2: "50%",
    y1: "10.758%",
    y2: "98.097%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#82F2D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4BE1AC",
    stopOpacity: 0.457
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "231.7%",
    height: "325%",
    x: "-65.9%",
    y: "-112.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M260.534 298.967l-157.86 90.887c-4.702 2.675-7.662 6.66-7.674 11.146.012 4.486 2.978 8.47 7.673 11.146l157.861 90.887c4.742 2.716 10.611 3.955 16.469 3.967 5.858-.012 11.727-1.251 16.468-3.967l157.861-90.887c4.696-2.675 7.662-6.66 7.668-11.146-.006-4.486-2.972-8.47-7.668-11.146l-157.86-90.887c-4.742-2.71-10.611-3.955-16.47-3.967-5.863.012-11.726 1.257-16.468 3.967l2.892 1.994c3.556-2.059 8.558-3.206 13.577-3.195 5.013-.011 10.02 1.136 13.577 3.195l160.861 93.886c3.603 2.105 4.788 4.377 4.777 6.153.011 1.776-1.174 4.054-4.777 6.153l-160.86 93.886c-3.557 2.065-8.565 3.206-13.578 3.195-5.014.011-10.021-1.13-13.577-3.195l-160.861-93.886c-3.603-2.1-4.788-4.377-4.783-6.153-.005-1.776 1.18-4.054 4.783-6.153l160.86-93.886-1.445-2.497-1.446.503z",
    opacity: 0.428,
    transform: "translate(-11 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7A8AC",
    d: "M198.457 403.953c-2.118 1.211-3.452 3.016-3.457 5.047.005 2.031 1.342 3.836 3.457 5.047l71.124 41.157c2.137 1.23 4.781 1.79 7.42 1.796 2.64-.005 5.284-.567 7.42-1.796l71.124-41.157c2.116-1.211 3.452-3.016 3.455-5.047-.003-2.031-1.34-3.836-3.455-5.047l-71.124-41.157c-2.136-1.227-4.78-1.79-7.42-1.796-2.641.005-5.283.57-7.42 1.796l-71.124 41.157z",
    filter: "url(#prefix__a)",
    opacity: 0.278,
    transform: "translate(-11 -56)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M131.4 168.22V133.9h29.312v-25.2H131.4V2.62H98.12L.92 108.7v25.2h97.2v34.32h33.28zM98.12 108.7H40.7l57.42-64.156V108.7zm167.616 25.26c47.808 0 80.448-23.087 80.448-66.305 0-42.959-32.64-66.816-80.448-66.816-48.143 0-81.121 23.857-81.121 66.816 0 43.218 32.978 66.304 81.121 66.304zm0-25.552c-26.688 0-47.44-14.4-47.44-40.753 0-26.35 21.087-41.262 47.44-41.262 26.353 0 46.769 15.168 46.769 41.262 0 26.353-20.754 40.753-46.769 40.753zm236.352 59.812V133.9H531.4v-25.2h-29.312V2.62h-33.28l-97.2 106.079v25.2h97.2v34.32h33.28zm-33.28-59.52h-57.42l57.42-64.156V108.7z",
    transform: "translate(-11 -56) translate(11 56)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M165.534 36.967L7.674 127.854C2.971 130.529.011 134.514 0 139c.012 4.486 2.978 8.47 7.673 11.146l157.861 90.887c4.742 2.716 10.611 3.955 16.469 3.967 5.858-.012 11.727-1.251 16.468-3.967l157.861-90.887c4.696-2.675 7.662-6.66 7.668-11.146-.006-4.486-2.972-8.47-7.668-11.146l-157.86-90.887c-4.742-2.71-10.611-3.955-16.47-3.967-5.863.012-11.726 1.257-16.468 3.967l2.892 4.994c3.556-2.059 8.558-3.206 13.577-3.195 5.013-.011 10.02 1.136 13.577 3.195l157.861 90.886c3.603 2.105 4.788 4.377 4.777 6.153.011 1.776-1.174 4.054-4.777 6.153l-157.86 90.886c-3.557 2.065-8.565 3.206-13.578 3.195-5.014.011-10.021-1.13-13.577-3.195L10.565 145.153c-3.603-2.1-4.788-4.377-4.783-6.153-.005-1.776 1.18-4.054 4.783-6.153l157.86-90.886-1.445-2.497-1.446-2.497z",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE1EA",
    d: "M264 142.58c0 4.407-3.09 9.803-6.925 12.02l-68.663 39.744c-1.918 1.098-4.422 1.656-6.925 1.656-2.504 0-5.008-.558-6.899-1.656L105.925 154.6C102.09 152.383 99 146.987 99 142.58V48h165v94.58z",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C8D4",
    d: "M182 48v148c-2.52 0-5.038-.558-6.941-1.656L105.968 154.6c-3.86-2.217-6.968-7.613-6.968-12.02V48h83",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDF4",
    d: "M174.58 1.667l-72.713 42.307c-3.823 2.222-3.823 5.83 0 8.052l72.713 42.307c3.822 2.223 10.018 2.223 13.84 0l72.713-42.307c3.823-2.222 3.823-5.83 0-8.052L188.42 1.667c-3.822-2.223-10.018-2.223-13.84 0",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283482",
    d: "M209 116.617v28.026c0 2.994 2.087 4.209 4.629 2.724l.802-.486 23.278-13.553c1.284-.726 2.435-2.025 3.291-3.51L210.391 112c-.856 1.458-1.391 3.105-1.391 4.617",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F1227",
    d: "M241.999 98.26l-.027-.922c.027-2.974-2.063-4.19-4.636-2.703l-.429.246-23.637 13.76c-1.287.756-2.44 2.027-3.27 3.514L240.659 130c.83-1.46 1.367-3.11 1.34-4.57V98.26",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D5AF0",
    d: "M237 121.53c.026 1.458-.504 3.048-1.352 4.509-.821 1.431-1.96 2.703-3.232 3.443l-23.072 13.306L209 143v-26.533c0-1.484.53-3.1 1.377-4.532.822-1.458 1.96-2.704 3.232-3.446L236.973 95l.026 26.53",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1543",
    d: "M155 116.617v28.026c0 2.994-2.087 4.209-4.629 2.724l-.802-.486-23.278-13.553c-1.284-.726-2.435-2.025-3.291-3.51L153.609 112c.856 1.458 1.391 3.105 1.391 4.617",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#192046",
    d: "M122.001 98.26l.027-.922c-.027-2.974 2.063-4.19 4.636-2.703l.429.246 23.637 13.76c1.287.756 2.44 2.027 3.27 3.514L123.341 130c-.83-1.46-1.367-3.11-1.34-4.57V98.26",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A1A6D",
    d: "M128.352 126.039c.821 1.431 1.96 2.703 3.232 3.443l23.072 13.306.344.212v-26.533c0-1.484-.53-3.1-1.377-4.532-.822-1.458-1.96-2.704-3.232-3.446L127.027 95l-.026 26.53c-.027 1.458.503 3.048 1.35 4.509z",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    d: "M174.58 1.667l-72.713 42.307c-3.823 2.222-3.823 5.83 0 8.052l72.713 42.307c3.822 2.223 10.018 2.223 13.84 0l72.713-42.307c3.823-2.222 3.823-5.83 0-8.052L188.42 1.667c-3.822-2.223-10.018-2.223-13.84 0",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39AB85",
    d: "M210.08 50.136l-.773.45-23.193 13.33c-1.253.74-2.906 1.084-4.586 1.084-1.68 0-3.359-.344-4.638-1.084l-23.194-13.33-.8-.45c-2.532-1.454-2.532-3.842.027-5.299l23.967-13.75c1.28-.74 2.959-1.087 4.638-1.087 1.68 0 3.333.37 4.612 1.086l23.94 13.751c2.56 1.457 2.56 3.845 0 5.3",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39AB85",
    d: "M182 30v35c-1.705 0-3.411-.344-4.71-1.084l-23.552-13.33-.813-.45c-2.571-1.454-2.571-3.842.028-5.299l24.337-13.75c1.299-.74 3.005-1.087 4.71-1.087",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    d: "M210 50.478l-23.356 13.423c-2.55 1.465-6.711 1.465-9.288 0L154 50.478l23.356-13.367c2.577-1.495 6.738-1.468 9.315 0L210 50.478",
    transform: "translate(-11 -56) translate(11 56) translate(84 174)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M54 95.796L15.229 73l-4.752 2.351c-1.484.734-2.443 2.276-2.476 3.985-.034 1.708.864 3.29 2.318 4.086L40.879 102 54 95.796z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.275 14.11s1.774-.546 2.596.795C18.693 16.245 20 29.059 20 29.059S19.918 38.9 16.493 39c0 0-4.678-23.549-1.218-24.89z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#281DE2",
    d: "M7.2 76.297s-.597 4.9.271 6.285c.87 1.385 3.866 2.228 3.498.248-.368-1.98-.666-6.83-.666-6.83l-3.102.297zM14.218 72.566L14 75.918l2.461 1.2.7-.338s3.237 2.215 6.839.676v-.713s-5.376-1.8-6.473-3.75c-1.096-1.95-3.309-.427-3.309-.427z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    d: "M5.317 37.689v21.475s-.906 10.502.344 16.66c0 0 2.332 2.647 4.711 0l-.247-13.571 1.534-12.83s.347 6.858 0 9.414c-.348 2.557 1.286 14.197 1.286 14.197 1.424.508 2.963.626 4.451.342V54.18L18 36s-4.635 2.003-12.683 1.689z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.12 37.573s4.871 2.656 8.506.72c1.869-.997 3.047-1.615 3.75-1.98.54-.277.845-.86.761-1.457-.295-2.265-.886-7.84.139-10.205 1.31-3.014 1.455-12.274-4.942-12.633C7.936 11.66 4 16.683 4 16.683l1.671 11.129.449 9.761z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.403 16.08c-.735.152-6.152 10.48-3.827 16.94 1.435 3.915 3.98 7.37 7.352 9.98L10 41.087 4.778 31.084s6.151-16.368-.375-15.003z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2CAE7",
    d: "M14.926 14.978c.02-.005.036-.02.038-.04.048-.63.112-2.274.112-2.274l.548-.155c2.506-.91.823-5.243.823-5.243s.134-.878-.444-3.379C15.08-.108 9.346.32 7.353 3.477 5.972 5.666 9.09 9.994 9.09 9.994l.724 2.928s2.159 2.326 5.112 2.056z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C9C6",
    d: "M9.179 42L10 42.957 7.532 45 7 43.98z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#281DE2",
    d: "M15 2.006s-.587.787-2.109.482c-1.15-.23-2.86 1.279-2.42 2.8.232.805.417 1.664.417 1.664l-.534.174s-.364-1.117-.921-.883c-.558.233 1.05 3.371-.294 3.757 0 0-3.895-5.334-1.173-8.236 2.722-2.902 6.412-1.792 7.034.242z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F74720",
    d: "M15.122 14L15.786 15.04 15.364 16.096 17 32.732 16.06 36 14.684 33.452 14.684 16.4 14 15.456 14.358 14.015z",
    transform: "translate(-11 -56) translate(11 56) translate(413 281)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    d: "M235 221.5L126.664 46.64l274.471-2.205C336.712 163.018 300.667 223.039 293 224.5c-6.342 1.208-31.691 3.014-54 .855-3.107-.301-4.44-1.586-4-3.855z",
    transform: "translate(-11 -56) translate(11 56)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    d: "M257.636 286.129L220 139l57.233 16.771c.561 92.553.22 139.142-1.023 139.77-1.243.627-7.435-2.51-18.574-9.412z",
    transform: "translate(-11 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M276.5 294.803L292.527 287.372 333.965 145.944 277.421 158.352z",
    transform: "translate(-11 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    d: "M257.636 286.129L220 139l57.233 16.771c.561 92.553.22 139.142-1.023 139.77-1.243.627-7.435-2.51-18.574-9.412z",
    transform: "translate(-11 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M276.5 294.803L292.527 287.372 333.965 145.944 277.421 158.352z",
    transform: "translate(-11 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#55DCAC",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M407 285.34v18.962c-.002 1.06-.547 2.04-1.433 2.58l-14.65 8.937c-.393.238-.88.241-1.275.01-.396-.233-.64-.665-.642-1.134v-18.962c-.005-1.062.541-2.046 1.433-2.58l14.597-8.938c.395-.267.901-.287 1.315-.05.414.235.666.688.655 1.174zM214 416.34v18.962c-.002 1.06-.547 2.04-1.433 2.58l-14.65 8.937c-.393.238-.88.241-1.275.01-.396-.233-.64-.665-.642-1.134v-18.962c-.005-1.062.541-2.046 1.433-2.58l14.597-8.938c.395-.267.901-.287 1.315-.05.414.235.666.688.655 1.174z",
    transform: "translate(-11 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75F6C9",
    fillOpacity: 0.259,
    stroke: "#55DCAC",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M161 271.16c.014 1.536-.869 3.008-2.311 3.853l-23.627 13.99c-.633.384-1.423.43-2.061.12-.638-.311-1.021-.929-1-1.611V260.38c-.015-1.536.868-3.008 2.31-3.853l23.627-14.203c.633-.384 1.423-.43 2.061-.12.638.31 1.021.928 1 1.61v27.345z",
    transform: "translate(-11 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5EDDB0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M170 337.664v9.468c.004.532-.27 1.025-.717 1.291l-7.333 4.485c-.196.121-.441.123-.64.004-.197-.12-.316-.34-.31-.576v-9.468c-.004-.532.27-1.025.717-1.291l7.333-4.485c.196-.121.441-.123.64-.004.197.12.316.34.31.576h0z",
    transform: "translate(-11 -56)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg404, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/404.faf9bdb3.svg";
export { ForwardRef as ReactComponent };